import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, ShieldCheck, Clock, Award } from 'lucide-react';

const GuaranteeSection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #2A1118 0%, #1A0A0E 100%)' }}>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 30% 70%, rgba(201,168,92,0.2) 0%, transparent 50%)' }}></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-400 mb-3">Our Promise</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">Your Brand Protection Guarantee</h2>
          <p className="text-wine-300">We stand behind our work with dedicated support and transparent service at every step.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            { icon: ShieldCheck, title: 'Expert Filing', desc: 'Every application reviewed and filed by licensed trademark attorneys with deep USPTO expertise.' },
            { icon: Clock, title: 'Timely Updates', desc: 'Regular status updates and prompt handling of all USPTO communications and office actions.' },
            { icon: Award, title: 'Dedicated Support', desc: 'A personal case manager assigned to guide you from initial search through final approval.' },
          ].map((item) => (
            <div key={item.title} className="group text-center bg-wine-900/40 border border-wine-800/40 rounded-xl p-8 hover:border-gold-400 hover:bg-wine-800/50 hover:-translate-y-1 hover:shadow-xl hover:shadow-gold-500/15 transition-all duration-300 cursor-default">
              <div className="w-14 h-14 bg-wine-800 border border-wine-700/50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-gold-500 group-hover:border-gold-400 transition-all duration-300">
                <item.icon className="w-7 h-7 text-gold-400 group-hover:text-wine-950 transition-colors duration-300" strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-gold-400 transition-colors duration-300">{item.title}</h3>
              <p className="text-sm text-wine-400 leading-relaxed group-hover:text-wine-300 transition-colors duration-300">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button onClick={onOpenContactForm}
            className="bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-500 text-wine-950 font-semibold px-10 py-5 text-base shadow-lg shadow-gold-500/20 transition-all">
            Start Protecting Your Brand <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
